import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formatCurrencyVND, getPaymentMethod } from "../utils/CurrencyFormat";
import {
  Box,
  Button,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import swal from "sweetalert";

const CustomerOrder = () => {
  const [data, setData] = useState([]);
  const [detailData, setDetailData] = useState([]);
  const [open, setOpen] = useState(false);
  const [detailId, setDetailId] = useState(null);
  const [orderDetail, setOrderDetail] = useState({});
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpen = (id) => {
    setIsLoading(true);
    setOpen(true);
    setDetailId(id);
    setOrderDetail({});
    setDetailData([]);
  };

  const handleClose = (isReload) => {
    setOpen(false);
    setDetailId(null);
    if (isReload) {
      getData(clientId);
    }
  };

  const clientId = localStorage.getItem("client_id");
  useEffect(() => {
    setLoading(true);
    getData(clientId);
  }, [currentPage]);

  useEffect(() => {
    if (detailId != null) {
      setLoading(true);
      getDetailData();
      getOrderDetail();
    }
  }, [detailId]);

  const getData = (id) => {
    axios
      .get(`/api/v1/orders`, {
        params: {
          customerId: id,
          page: currentPage,
          limit: 10,
        },
      })
      .then((res) => {
        setData(res.data.orders);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const getDetailData = () => {
    axios
      .get(`/api/v1/order-details/get-by-order-id/` + detailId)
      .then(async (res) => {
        const fetchedData = res.data;

        const updatedData = await Promise.all(
          fetchedData.map(async (item) => {
            try {
              const response = await axios.get(
                `/api/v1/products/${item.productId}`
              );
              return {
                ...item,
                product: response.data,
              };
            } catch (error) {
              console.error(
                `Lỗi khi lấy thông tin sản phẩm ${item.productId}`,
                error
              );
              return { ...item, product: null };
            }
          })
        );
        setDetailData(updatedData);
        setLoading(false);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const getOrderDetail = () => {
    axios
      .get(`/api/v1/orders/` + detailId)
      .then((res) => {
        setOrderDetail(res.data);
        setLoading(false);
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const status = [
    {
      name: "Chờ xác nhận",
      value: 0,
    },
    {
      name: "Đã xác nhận",
      value: 1,
    },
    {
      name: "Đã giao",
      value: 2,
    },
    {
      name: "Đã huỷ",
      value: 3,
    },
  ];

  const getStatusName = (value) => {
    const statusItem = status.find((item) => item.value === value);
    return statusItem ? statusItem.name : "NaN";
  };

  const handleOrderCancel = () => {
    swal({
      title: `Bạn muốn huỷ đơn hàng này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Huỷ"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .put(`/api/v1/orders/${detailId}`, {
            status: 3,
          })
          .then((res) => {
            toast("Huỷ đơn hàng thành công", {
              type: "success",
              autoClose: 1000,
            });
            handleClose(true);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          height: "500px",
          overflowY: "auto",
          overflowX: "hidden",
          padding: "8px",
        }}
      >
        {data.map((item, idx) => (
          <div className="customer-order-item" key={idx}>
            <div className="order-code">
              <span style={{ color: "#ccc" }}>Mã: </span>#{item.id}
            </div>
            <div className="order-code">
              <span style={{ color: "#ccc" }}>KH: </span>
              {item.fullName}
            </div>
            <div className="order-price">
              <span style={{ color: "#ccc" }}>Giá: </span>
              {formatCurrencyVND(item.totalPrice)}
            </div>
            <div className="order-status">
              <span style={{ color: "#ccc" }}>Trạng thái: </span>
              <span
                style={{
                  color: `${
                    item.status == 0
                      ? "#ccc"
                      : item.status == 1
                      ? "#0183b7"
                      : item.status == 2
                      ? "green"
                      : "red"
                  }`,
                }}
              >
                {getStatusName(item.status)}
              </span>
            </div>
            <div
              className="order-detail-view"
              onClick={() => handleOpen(item.id)}
            >
              Xem chi tiết
            </div>
          </div>
        ))}
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90vw", sm: "50vw" },
              height: "95vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: { xs: 2, sm: 4 },
              borderRadius: 2,
              overflowX: "hidden",
              overflowY: "auto",
            }}
          >
            <Typography
              id="modal-title"
              variant="h5"
              component="h2"
              sx={{ textAlign: "center", pb: 2 }}
            >
              Chi tiết hoá đơn
            </Typography>
            <Box
              sx={{
                p: " 10px 0 20px 0",
                borderTop: "1px solid #ccc",
                borderBottom: "1px solid #ccc",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: "0 20px",
                  pb: 2,
                }}
              >
                <b>Sản Phẩm</b>
                <b>Giá Tiền</b>
              </Box>
              {detailData.map((item, idx) => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    p: "10px 20px",
                  }}
                  key={idx}
                >
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <Box
                      component="img"
                      sx={{
                        width: "5vw",
                        height: "15vh",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                      alt=""
                      src={item.product.image ?? ""}
                    />
                    <Box>
                      {item.product.name}
                      <b className="ms-2"> x {item.quantity}</b>
                    </Box>
                  </Box>
                  <Box sx={{ fontWeight: "bold" }}>
                    {formatCurrencyVND(item.product.price * item.quantity)}
                  </Box>
                </Box>
              ))}
              {isLoading && (
                <Box sx={{ width: "100%", textAlign: "center" }}>
                  <CircularProgress sx={{ color: "#0184b7" }} />
                </Box>
              )}
            </Box>
            {isLoading ? (
              <Box sx={{ width: "100%", textAlign: "center", pt: 3 }}>
                <CircularProgress sx={{ color: "#0184b7" }} />
              </Box>
            ) : (
              <Box
                sx={{
                  p: "0 20px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 2,
                  }}
                >
                  <b>VAT (10%)</b>
                  <b>
                    {orderDetail.isVat
                      ? formatCurrencyVND(orderDetail.vatPrice)
                      : formatCurrencyVND(0)}
                  </b>
                </Box>
                {orderDetail.isVat && (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 2,
                      }}
                    >
                      <b>Tên công ty</b>
                      <p style={{ margin: 0 }}>{orderDetail.companyName}</p>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 2,
                      }}
                    >
                      <b>Mã số thuế</b>
                      <p style={{ margin: 0 }}>{orderDetail.companyTax}</p>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 2,
                      }}
                    >
                      <b>Email công ty</b>
                      <p style={{ margin: 0 }}>{orderDetail.companyEmail}</p>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pt: 2,
                      }}
                    >
                      <b>Địa chỉ công ty</b>
                      <p style={{ margin: 0 }}>{orderDetail.companyAddress}</p>
                    </Box>
                    <hr />
                  </>
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 2,
                  }}
                >
                  <b>Tổng tiền</b>
                  <b>{formatCurrencyVND(orderDetail.totalPrice)}</b>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pt: 2,
                  }}
                >
                  <b>Hình thức thanh toán</b>
                  <b>{getPaymentMethod(orderDetail.payment)}</b>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    pt: 2,
                    gap: 1,
                  }}
                >
                  <b>Địa chỉ: </b>
                  {orderDetail.address}
                </Box>
              </Box>
            )}
            <Box sx={{ justifyContent: "end", pt: 3, gap: 3, display: "flex" }}>
              {orderDetail.status == 0 && (
                <Button
                  variant="contained"
                  color="info"
                  onClick={handleOrderCancel}
                  sx={{ mt: 2 }}
                >
                  Huỷ đơn
                </Button>
              )}
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
                sx={{ mt: 2 }}
              >
                Đóng
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
      <div className="pagination">
        <button
          className={`page-button ${currentPage == 1 ? "active" : ""}`}
          id="prev-btn"
          disabled={currentPage == 1}
          onClick={() => goToPage(currentPage - 1)}
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        <span className="page-numbers">
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={`page-number ${
                index + 1 === currentPage ? "active" : ""
              }`}
              onClick={() => goToPage(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </span>
        <button
          className={`page-button ${currentPage == totalPages ? "active" : ""}`}
          id="next-btn"
          disabled={currentPage == totalPages}
          onClick={() => goToPage(currentPage + 1)}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <CircularProgress sx={{ color: "#0184b7" }} />
        </Box>
      )}
    </Box>
  );
};

export default CustomerOrder;
